/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Section_WhoInputs */



/**
* | output |
* | --- |
* | "Who is it for?" |
*
* @param {Signup_Compare_Section_WhoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_section_who = /** @type {((inputs?: Signup_Compare_Section_WhoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Section_WhoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Who is it for?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Who is it for?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Who is it for?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Who is it for?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Who is it for?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Who is it for?")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Who is it for?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Who is it for?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Who is it for?")
	return /** @type {LocalizedString} */ ("Who is it for?")
});